import React, { Component } from 'react';
import { withCookies } from 'react-cookie';
import { inject, observer } from 'mobx-react';
import _ from 'lodash';
import * as Sentry from '@sentry/browser';
import actions from 'api/actions';
import RootModelStore from 'stores/root-model-store';

const ConnectedTrialConfirmSubmit = withCookies(
  inject(
    'sessionStore',
    'routing',
  )(
    observer(
      class TrialConfirmSubmit extends Component {
        constructor(props) {
          super(props);

          this.state = { error: false };
        }

        componentDidMount() {
          const { id, token } = this.props.match.params;
          actions
            .post('users/confirm', { user_id: id, confirmation_token: token })
            .then(r => {
              this.props.sessionStore.login({ ...r.data }, this.props.cookies);
              _.forEach(RootModelStore.stores, store => store.reset());
              this.props.routing.push('/');
            })
            .catch(e => {
              console.error('Error', e);
              Sentry.withScope(scope => {
                scope.setExtra('user_id', id);
                scope.setExtra('confirmation_token', token);
                Sentry.captureException(e);
              });
              this.setState({ error: true });
            });
        }

        render() {
          return (
            <div className="row">
              <div className="col-md-6 offset-md-3 my-5">
                <div className="card register-panel">
                  <div className="card-body">
                    {this.state.error ? (
                      <p className="text-center">
                        Your confirmation is invalid!
                      </p>
                    ) : (
                      <p className="text-center">
                        Confirming account and logging in...
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          );
        }
      },
    ),
  ),
);

export default ConnectedTrialConfirmSubmit;
